<template>
  <loader v-if="isLoader" />
  <div class="container-fluid" v-if="!isLoader">
    <!-- Header and Chart Row -->
    <div class="row">
      <!-- Header -->
      <div class="col-12 header">
        <div class="row">
          <div class="col-lg-3 logo-container">
            <a href="/#/"  v-if="false">
            <img
              src="@/assets/images/logo-lg-light.svg"
              alt="#"
              v-if="theme == 'light'"
            />
            </a>

           <a href="/#/"  v-if="false">
            <img
              src="@/assets/images/logo-lg-medium.svg"
              alt="#"
              v-if="theme == 'medium'"
            />
            </a>

            <a href="/#/"  v-if="false">
            <img
              src="@/assets/images/logo-lg-light.svg"
              alt="#"
              v-if="theme == 'dark'"
            />
            </a>
          </div>
          <div class="col-lg-6 dash-heading-container">
            <h1 v-if="lang == 'ar'">لوحة أداء المشاریع الإستراتیجیة</h1>
            <h1 v-if="lang == 'en'">Strategic Projects Dashboard</h1>
            <div class="line"></div>
          </div>
          <div class="col-lg-3 custom-dropdown-container">
             <div class="arrowlogo">
               <img 
              src="@/assets/images/arrow-h-dark.png"
              alt="#"
              v-if="theme == 'dark'"/>
              <img 
              src="@/assets/images/arrow-h-medium.png"
              alt="#"
              v-if="theme == 'medium'"/>
              <img 
              src="@/assets/images/arrow-h-light.png"
              alt="#"
              v-if="theme == 'light'"/>
            </div>
            <div class="togglers">
              <lang-toggler-v3></lang-toggler-v3>
              <theme-toggler-v3></theme-toggler-v3>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 tiles-section">
        <div class="lg-tile-proto">
          <div class="tilehead">
            <img src="@/assets/images/icons/v3-dollar-dark.svg" alt="#" />
            <h1 v-if="lang == 'ar'">میزانیة المشاریع الإجمالیة (ر.س)</h1>
            <h1 v-if="lang == 'en'">Total Projects Budget (SAR)</h1>
          </div>
          <div class="content-container">
            <div class="tile-proto">
              <img
                src="@/assets/images/icons/v3-prism.svg"
                alt="#"
                v-if="theme == 'dark' || theme == 'medium'"
              />
              <img
                src="@/assets/images/icons/v3-prism-light.svg"
                alt="#"
                v-if="theme == 'light'"
              />

              <h1 v-if="lang == 'ar'">إجمالي المشاریع</h1>
              <h1 v-if="lang == 'en'">Total Projects</h1>
              <h2 class="purple">{{ projectData.projects.length }}</h2>
            </div>

            <div class="tile-proto">
              <img
                src="@/assets/images/icons/v3-note.svg"
                alt="#"
                v-if="theme == 'dark' || theme == 'medium'"
              />
              <img
                src="@/assets/images/icons/v3-note-light.svg"
                alt="#"
                v-if="theme == 'light'"
              />

              <h1 v-if="lang == 'ar'">اجمالي العقود</h1>
              <h1 v-if="lang == 'en'">Total Contract Value</h1>
              <h2 class="green small">
                {{ projectData.contractValue }}
              </h2>
            </div>
            <div class="chart-holder">
              <circular-progress-v3
                id="cirp-1"
                :per="projectData.progressChart.allPercentageValue"
                name="اجمالي العقود"
              />
            </div>
            <div class="list-holder">
              <div class="list">
                <img
                  src="@/assets/images/icons/v3-tick.svg"
                  alt="#"
                  v-if="theme == 'dark' || theme == 'medium'"
                />
                <img
                  src="@/assets/images/icons/v3-tick-light.svg"
                  alt="#"
                  v-if="theme == 'light'"
                />

                <h1 v-if="lang == 'ar'">المعتمد</h1>
                <h1 v-if="lang == 'en'">Approved</h1>
                <h2>{{ projectData.approvedBudget }}</h2>
              </div>
              <div class="list">
                <img
                  src="@/assets/images/icons/forwarded-v2.svg"
                  alt="#"
                  v-if="theme == 'dark' || theme == 'medium'"
                />
                <img
                  src="@/assets/images/icons/v3-forward-light.svg"
                  alt="#"
                  v-if="theme == 'light'"
                />

                <h1 v-if="lang == 'ar'">المنصرف</h1>
                <h1 v-if="lang == 'en'">Spent</h1>
                <h2 class="blue">{{ projectData.paidAmount }}</h2>
              </div>
            </div>
          </div>
        </div>
        <div class="lg-tile-proto">
          <div class="tilehead">
            <img src="@/assets/images/icons/v3-dollar-dark.svg" alt="#" />

            <h1 v-if="lang == 'ar'">
              میزانیة المشاریع الإجمالیة - السنة الحالية(2022)
            </h1>
            <h1 v-if="lang == 'en'">
              Total Projects Budget (SAR) - Current Year
            </h1>
          </div>
          <div class="content-container">
            <div class="tile-proto">
              <img
                src="@/assets/images/icons/v3-prism.svg"
                alt="#"
                v-if="theme == 'dark' || theme == 'medium'"
              />
              <img
                src="@/assets/images/icons/v3-prism-light.svg"
                alt="#"
                v-if="theme == 'light'"
              />
              <h1 v-if="lang == 'ar'">إجمالي المشاریع</h1>
              <h1 v-if="lang == 'en'">Total Projects</h1>
              <h2 class="purple">{{ projectData.currentYear.totalProject }}</h2>
            </div>

            <div class="tile-proto">
              <img
                src="@/assets/images/icons/v3-note.svg"
                alt="#"
                v-if="theme == 'dark' || theme == 'medium'"
              />
              <img
                src="@/assets/images/icons/v3-note-light.svg"
                alt="#"
                v-if="theme == 'light'"
              />
              <h1 v-if="lang == 'ar'">اجمالي العقود</h1>
              <h1 v-if="lang == 'en'">Total Contract Value</h1>
              <h2 class="green small">
                {{ projectData.currentYear.contractValue }}
              </h2>
            </div>
            <div class="chart-holder">
              <circular-progress-v3
                id="cirp-2"
                :per="projectData.progressChart.currentYearPercentageValue"
                name="اجمالي العقود"
              />
            </div>
            <div class="list-holder">
              <div class="list">
                <img
                  src="@/assets/images/icons/v3-tick.svg"
                  alt="#"
                  v-if="theme == 'dark' || theme == 'medium'"
                />
                <img
                  src="@/assets/images/icons/v3-tick-light.svg"
                  alt="#"
                  v-if="theme == 'light'"
                />
                <h1 v-if="lang == 'ar'">المعتمد</h1>
                <h1 v-if="lang == 'en'">Approved</h1>
                <h2>{{ projectData.currentYear.approvedBudget }}</h2>
              </div>
              <div class="list">
                <img
                  src="@/assets/images/icons/forwarded-v2.svg"
                  alt="#"
                  v-if="theme == 'dark' || theme == 'medium'"
                />
                <img
                  src="@/assets/images/icons/v3-forward-light.svg"
                  alt="#"
                  v-if="theme == 'light'"
                />
                <h1 v-if="lang == 'ar'">المنصرف</h1>
                <h1 v-if="lang == 'en'">Spent</h1>
                <h2 class="blue">{{ projectData.currentYear.paidAmount }}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 chart-container">
        <div class="chart-tile">
          <h2 class="floating-number">
            {{
              projectData.projects.filter((item) => item.ProjectType == "داخلي")
                .length
            }}
          </h2>
          <div class="tilehead">
            <img
              src="@/assets/images/icons/v3-briefcase.svg"
              alt="#"
              class="tilehead-icon"
            />

            <span v-if="lang == 'ar'">المشاریع الداخلیة</span>
            <span v-if="lang == 'en'">Internal Projects</span>
          </div>
          <circular-pie-v3
            id="cirpie1"
            :data="this.projectData.internalProjects"
            v-if="this.projectData.internalProjects.isData"
          ></circular-pie-v3>
        </div>
        <div class="chart-tile">
          <h2 class="floating-number">
            {{
              projectData.projects.filter((item) => item.ProjectType == "خارجي")
                .length
            }}
          </h2>
          <div class="tilehead">
            <img
              src="@/assets/images/icons/v3-rocket.svg"
              alt="#"
              class="tilehead-icon"
            />

            <span v-if="lang == 'ar'">المشاریع الخارجیة</span>
            <span v-if="lang == 'en'">External Projects</span>
          </div>
          <circular-pie-v3
            id="cirpie2"
            :data="this.projectData.externalProjects"
            v-if="this.projectData.externalProjects.isData"
          ></circular-pie-v3>
        </div>
        <div class="chart-tile">
          <h2 class="floating-number">
            {{ projectData.projectSector.totalSectors }}
          </h2>
          <div class="tilehead">
            <img
              src="@/assets/images/icons/v3-cogs.svg"
              alt="#"
              class="tilehead-icon"
            />

            <span v-if="lang == 'ar'">المشاریع حسب القطاع</span>
            <span v-if="lang == 'en'">Projects By Sector</span>
          </div>
          <dynamic-circular-pie-v3
            id="cirpie3"
            :chartData="this.projectData.projectSector.labels"
            v-if="this.projectData.projectSector.isData"
          ></dynamic-circular-pie-v3>
        </div>
      </div>
    </div>

    <!-- Donut Charts -->
    <div class="row">
      <div class="col-12 chart-container">
        <div class="chart-tile" style="justify-content: flex-start">
          <h2 class="floating-number">
            {{ projectData.contractStatus.totalContracts }}
          </h2>
          <div class="tilehead">
            <img
              src="@/assets/images/icons/v3-notes.svg"
              alt="#"
              class="tilehead-icon"
            />

            <span v-if="lang == 'ar'">كراسات الطرح</span>
            <span v-if="lang == 'en'">RFP Status</span>
          </div>
          <pie-v3
            id="pie1"
            :chartData="this.projectData.contractStatus.labels"
            :chartColors="this.projectData.contractStatus.colors"
            v-if="this.projectData.contractStatus.isData"
          />
        </div>
        <div class="chart-tile" style="justify-content: flex-start">
          <h2 class="floating-number">{{ projectData.catEfada.totalEfada }}</h2>
          <div class="tilehead">
            <img
              src="@/assets/images/icons/v3-folder.svg"
              alt="#"
              class="tilehead-icon"
            />
            <span v-if="lang == 'ar'">تصنیف المشاریع</span>
            <span v-if="lang == 'en'">Project Classification</span>
          </div>
          <pie-v3
            id="pie2"
            :chartData="this.projectData.catEfada.labels"
            :chartColors="this.projectData.catEfada.colors"
            v-if="this.projectData.catEfada.isData"
          />
        </div>
        <div class="chart-tile">
          <h2 class="floating-number">{{ projectData.projects.length }}</h2>
          <div class="tilehead">
            <img
              src="@/assets/images/icons/v3-comment.svg"
              alt="#"
              class="tilehead-icon"
            />
            <span v-if="lang == 'ar'">حالة المشاریع</span>
            <span v-if="lang == 'en'">Project Status</span>
          </div>
          <circular-pie-filter-v3
            id="cirpie4"
            :pieChartData="projectData.pieChart"
            v-if="projectData.pieChart.isData"
          />
        </div>
      </div>
    </div>

    <!-- 6*6 Tables -->
    <div class="row">
      <div class="col-lg-12 risks">
        <h1 class="table-title" v-if="lang == 'ar'">المخاطر</h1>
        <h1 class="table-title" v-if="lang == 'en'">Risks</h1>
        <div
          :class="filter.risk == 'all' ? 'table-tiles active' : 'table-tiles'"
          @click="filterRisks('all')"
        >
          <img
            src="@/assets/images/icons/all.svg"
            alt="#"
            class="icon"
            v-if="theme == 'light'"
          />
          <img
            src="@/assets/images/icons/v3-risk-all.svg"
            alt="#"
            class="icon"
            v-if="theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/all-dark.svg"
            alt="#"
            class="icon"
            v-if="theme == 'dark'"
          />

          <h1 v-if="lang == 'ar'">الكل</h1>
          <h1 v-if="lang == 'en'">All</h1>
          <h2>{{ projectData.risks.length }}</h2>
        </div>
        <div
          :class="filter.risk == '5' ? 'table-tiles active' : 'table-tiles'"
          @click="filterRisks('5')"
        >
          <img src="@/assets/images/icons/veryhigh.svg" alt="#" class="icon" />
          <h1 v-if="lang == 'ar'">خطير جدا</h1>
          <h1 v-if="lang == 'en'">Very High</h1>
          <h2>
            {{ projectData.risks.filter((item) => item.Exposure >= 5).length }}
          </h2>
        </div>
        <div
          :class="filter.risk == '4' ? 'table-tiles active' : 'table-tiles'"
          @click="filterRisks('4')"
        >
          <img src="@/assets/images/icons/high.svg" alt="#" class="icon" />
          <h1 v-if="lang == 'ar'">خطير</h1>
          <h1 v-if="lang == 'en'">High</h1>
          <h2>
            {{ projectData.risks.filter((item) => item.Exposure == 4).length }}
          </h2>
        </div>
        <div
          :class="filter.risk == '3' ? 'table-tiles active' : 'table-tiles'"
          @click="filterRisks('3')"
        >
          <img src="@/assets/images/icons/moderate.svg" alt="#" class="icon" />
          <h1 v-if="lang == 'ar'">متوسط</h1>
          <h1 v-if="lang == 'en'">Medium</h1>
          <h2>
            {{ projectData.risks.filter((item) => item.Exposure == 3).length }}
          </h2>
        </div>
        <div
          :class="filter.risk == '2' ? 'table-tiles active' : 'table-tiles'"
          @click="filterRisks('2')"
        >
          <img
            src="@/assets/images/icons/less.svg"
            alt="#"
            class="icon"
            v-if="theme == 'dark'"
          />
          <img
            src="@/assets/images/icons/v3-risk-low.svg"
            alt="#"
            class="icon"
            v-if="theme == 'medium' || theme == 'light'"
          />
          <h1 v-if="lang == 'ar'">خفيف</h1>
          <h1 v-if="lang == 'en'">Low</h1>
          <h2>
            {{ projectData.risks.filter((item) => item.Exposure == 2).length }}
          </h2>
        </div>
        <div
          :class="
            filter.risk == '1' ? 'table-tiles active last' : 'table-tiles last'
          "
          @click="filterRisks('1')"
        >
          <img
            src="@/assets/images/icons/nonimpact.svg"
            alt="#"
            class="icon"
            v-if="theme == 'dark'"
          />
          <img
            src="@/assets/images/icons/nonimpact.svg"
            alt="#"
            class="icon"
            v-if="theme == 'medium' || theme == 'light'"
          />
          <h1 v-if="lang == 'ar'">غير مؤثر</h1>
          <h1 v-if="lang == 'en'">No Impact</h1>
          <h2>
            {{ projectData.risks.filter((item) => item.Exposure == 0).length }}
          </h2>
        </div>

        <div class="table-wrapper">
          <table class="risk-table">
            <thead>
              <tr>
                <th v-if="lang == 'ar'">اسم الخطر</th>
                <th v-if="lang == 'en'">Title</th>
                <th v-if="lang == 'ar'">اسم المشروع</th>
                <th v-if="lang == 'en'">Project Name</th>
                <th v-if="lang == 'ar'">نوع الخطر</th>
                <th v-if="lang == 'en'">Type</th>
                <th v-if="lang == 'ar'">القطاع</th>
                <th v-if="lang == 'en'">Sector</th>
                <th class="center" v-if="lang == 'ar'">التأثير</th>
                <th class="center" v-if="lang == 'en'">Exposure</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="risk in filteredRisks" :key="risk.status">
                <td>{{ risk.RiskTitle }}</td>
                <td>{{ risk.ProjectName }}</td>
                <td>{{ risk.RiskType }}</td>
                <td>{{ risk.القطاع }}</td>
                <td class="center">
                  <span v-if="risk.Exposure == '1'" class="low">
                    غير مؤثر
                  </span>
                  <span v-if="risk.Exposure == '2'" class="low">
                    تأثير خفيف
                  </span>
                  <span v-if="risk.Exposure == '3'" class="medium">
                    متوسط
                  </span>
                  <span v-if="risk.Exposure == '4'" class="high"> خطير </span>
                  <span v-if="risk.Exposure >= '5'" class="high">
                    خطير جدا
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="false" class="col-lg-6 issues">
        <h1 class="table-title" v-if="lang == 'ar'">التحديات</h1>
        <h1 class="table-title" v-if="lang == 'en'">Issues</h1>
        <div
          :class="filter.issue == 'all' ? 'table-tiles active' : 'table-tiles'"
          @click="filterIssues('all')"
        >
          <img
            src="@/assets/images/icons/warning-all.svg"
            alt="#"
            class="icon"
            v-if="theme == 'light'"
          />
          <img
            src="@/assets/images/icons/v3-issue-all.svg"
            alt="#"
            class="icon"
            v-if="theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/warning-all-dark.svg"
            alt="#"
            class="icon"
            v-if="theme == 'dark'"
          />

          <h1 v-if="lang == 'ar'">الكل</h1>
          <h1 v-if="lang == 'en'">All</h1>
          <h2>10</h2>
        </div>
        <div
          :class="filter.issue == 'high' ? 'table-tiles active' : 'table-tiles'"
          @click="filterIssues('high')"
        >
          <img
            src="@/assets/images/icons/warning-high.svg"
            alt="#"
            class="icon"
          />
          <h1 v-if="lang == 'ar'">ارتفاع</h1>
          <h1 v-if="lang == 'en'">High</h1>
          <h2>2</h2>
        </div>
        <div
          :class="
            filter.issue == 'medium' ? 'table-tiles active' : 'table-tiles'
          "
          @click="filterIssues('medium')"
        >
          <img
            src="@/assets/images/icons/warning-moderate.svg"
            alt="#"
            class="icon"
          />
          <h1 v-if="lang == 'ar'">متوسط</h1>
          <h1 v-if="lang == 'en'">Medium</h1>
          <h2>3</h2>
        </div>
        <div
          :class="
            filter.issue == 'low'
              ? 'table-tiles active last'
              : 'table-tiles last'
          "
          @click="filterIssues('low')"
        >
          <img
            src="@/assets/images/icons/v3-issue-low.svg"
            alt="#"
            class="icon"
            v-if="theme == 'medium' || theme == 'light'"
          />
          <img
            src="@/assets/images/icons/warning-less.svg"
            alt="#"
            class="icon"
            v-if="theme == 'dark'"
          />

          <h1 v-if="lang == 'ar'">ليلق</h1>
          <h1 v-if="lang == 'en'">Low</h1>
          <h2>6</h2>
        </div>

        <table class="issue-table">
          <thead>
            <tr>
              <th>إسم المشروع</th>
              <th>تاریخ الإطلاق</th>
              <th class="center">الحالة</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="issue in filteredIssues" :key="issue.status">
              <td>{{ issue.name }}</td>
              <td class="date">{{ issue.date }}</td>
              <td class="center">
                <span v-if="issue.code == 'low'" class="low">{{
                  issue.status
                }}</span>
                <span v-if="issue.code == 'medium'" class="medium">{{
                  issue.status
                }}</span>
                <span v-if="issue.code == 'high'" class="high">{{
                  issue.status
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Data based on Tiles Fitlers -->
    <div class="row" id="databased-row">
      <div class="col-12 filter-based-data">
        <h1 v-if="lang == 'ar'">المشاریع الإستراتیجیة</h1>
        <h1 v-if="lang == 'en'">Strategic Projects</h1>
      </div>
      <div class="col-12 tab-data">
        <div
          :class="activeFilters.health == 'all' ? 'tabs active all' : 'tabs'"
          @click="filterProjects('all')"
        >
          <h1 v-if="lang == 'ar'">الكل</h1>
          <h1 v-if="lang == 'en'">All</h1>
          <div class="mark all">{{ projectData.projects.length }}</div>
        </div>
        <div
          :class="
            activeTab == 'تم الاطلاق(مكتمل)' ? 'tabs active completed' : 'tabs'
          "
          @click="filterProjects('تم الاطلاق(مكتمل)')"
        >
          <h1 v-if="lang == 'ar'">تم الاطلاق(مكتمل)</h1>
          <h1 v-if="lang == 'en'">Completed</h1>
          <div class="mark completed">
            {{
              projectData.projects.filter(
                (item) => item.ProjectStatus == "تم الاطلاق(مكتمل)"
              ).length
            }}
          </div>
        </div>
        <div
          :class="
            activeFilters.health == 'حسب المخطط'
              ? 'tabs active onplanned'
              : 'tabs'
          "
          @click="filterProjects('حسب المخطط')"
        >
          <h1 v-if="lang == 'ar'">حسب المخطط</h1>
          <h1 v-if="lang == 'en'">As Planned</h1>
          <div class="mark onplanned">
            {{
              projectData.projects.filter(
                (item) => item.ProjectStatus == "حسب المخطط"
              ).length
            }}
          </div>
        </div>
        <div
          :class="
            activeFilters.health == 'متوقع التأخير/ملاحظة مهمة'
              ? 'tabs active expectedlate'
              : 'tabs'
          "
          @click="filterProjects('متوقع التأخير/ملاحظة مهمة')"
        >
          <h1 v-if="lang == 'ar'">متوقع التأخير</h1>
          <h1 v-if="lang == 'en'">Expected Late</h1>
          <div class="mark expectedlate">
            {{
              projectData.projects.filter(
                (item) => item.ProjectStatus == "متوقع التأخير/ملاحظة مهمة"
              ).length
            }}
          </div>
        </div>
        <div
          :class="activeFilters.health == 'متأخر' ? 'tabs active late' : 'tabs'"
          @click="filterProjects('متأخر')"
        >
          <h1 v-if="lang == 'ar'">متأخر</h1>
          <h1 v-if="lang == 'en'">Late</h1>
          <div class="mark late">
            {{
              projectData.projects.filter(
                (item) => item.ProjectStatus == "متأخر"
              ).length
            }}
          </div>
        </div>

        <div
          :class="
            activeFilters.health == 'ملغي'
              ? 'tabs active archived'
              : 'tabs'
          "
          @click="filterProjects('ملغي')"
        >
          <h1 v-if="lang == 'ar'">ملغي</h1>
          <h1 v-if="lang == 'en'">Archived</h1>
          <div class="mark archived">
            {{
              projectData.projects.filter(
                (item) => item.ProjectStatus == "ملغي"
              ).length
            }}
          </div>
        </div>
      </div>

      <div class="col-12 markline-container">
        <img
          src="@/assets/images/line-all.svg"
          alt="#"
          v-if="activeFilters.health == 'all'"
        />
        <!-- <img src="@/assets/images/line-dark.svg" alt="#" v-if="activeTab =='all' && theme =='dark'"> -->
        <img
          src="@/assets/images/line-late.svg"
          alt="#"
          v-if="activeFilters.health == 'متأخر'"
        />
        <img
          src="@/assets/images/line-onplanned.svg"
          alt="#"
          v-if="activeFilters.health == 'حسب المخطط'"
        />
        <img
          src="@/assets/images/line-completed.svg"
          alt="#"
          v-if="activeFilters.health == 'تم الاطلاق(مكتمل)'"
        />
        <img
          src="@/assets/images/line-expectedlate.svg"
          alt="#"
          v-if="activeFilters.health == 'متوقع التأخير/ملاحظة مهمة'"
        />
      </div>
      <div class="col-12 tile-table">
        <div class="custom-filter">
          <div
            :class="projectData.tableView ? 'togg table active' : 'togg table'"
            @click="changeProjectView('table')"
          >
            <img src="@/assets/images/icons/v3-table-view.svg" alt="#" />
          </div>
          <div
            :class="projectData.tileView ? 'togg tile active' : 'togg tile'"
            @click="changeProjectView('tile')"
          >
            <img src="@/assets/images/icons/v3-tile-view.svg" alt="#" />
          </div>
        </div>

        <search-filter  v-if="false"/>
      </div>

      <div class="panel-wrapper">
        <template
          v-for="(item, index) in Object.values(activeFilters)"
          :key="item"
        >
          <div class="current-filters" v-if="item != '' && item !='all'">
            <span class="active-filter">{{ item }}</span>
            <img
              src="@/assets/images/icons/close-filter.svg"
              alt="#"
              v-if="theme == 'dark' || theme == 'medium'"
              @click="makeActiveFilterNone(index)"
            />
            <img
              src="@/assets/images/icons/close-filter-light.svg"
              alt="#"
              v-if="theme == 'light'"
              @click="makeActiveFilterNone(index)"
            />
          </div>
        </template>
      </div>
      <!-- Added filter panel -->
      <div class="col-12 filter-panel">
        <div class="dropdown-filter" @click="openProjectClassification">
          <img
            src="@/assets/images/icons/v3-angledown.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'light' || theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/angle-down-td.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'dark'"
          />
          <span v-if="lang == 'en'">Project Classification</span>
          <span v-if="lang == 'ar'">تصنيف المشاريع</span>

          <div class="filter-dropdown" v-if="isProjectClassification">
            <ul>
              <li
                @click="filterProjectsByClassification(label.key)"
                v-for="label in projectData.catEfada.labels"
                :key="label.key"
              >
                {{ label.key }}
                <span v-if="false">0</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="dropdown-filter" @click="openRFP">
          <img
            src="@/assets/images/icons/v3-angledown.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'light' || theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/angle-down-td.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'dark'"
          />
          <span v-if="lang == 'en'">RFP Status</span>
          <span v-if="lang == 'ar'">كراسات الطرح</span>

          <div class="filter-dropdown" v-if="isProjectRFP">
            <ul>
              <li
                @click="filterProjectsByRFP(label.key)"
                v-for="label in projectData.contractStatus.labels"
                :key="label.key"
              >
                {{ label.key }}
                <span v-if="false">0</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="dropdown-filter" @click="openProjectSector">
          <img
            src="@/assets/images/icons/v3-angledown.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'light' || theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/angle-down-td.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'dark'"
          />
          <span v-if="lang == 'en'">Project By Sector</span>
          <span v-if="lang == 'ar'">مشاريع حسب القطاع</span>

          <div class="filter-dropdown" v-if="isProjectSector">
            <ul>
              <li
                @click="filterProjectsBySector(label.key)"
                v-for="label in projectData.projectSector.labels"
                :key="label"
              >
                {{ label.key }}
                <span v-if="false">0</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="dropdown-filter" @click="openProjectType">
          <img
            src="@/assets/images/icons/v3-angledown.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'light' || theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/angle-down-td.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'dark'"
          />
         <span v-if="lang == 'en'">Project Type</span>
          <span v-if="lang == 'ar'">نوع المشروع</span>
          <div class="filter-dropdown" v-if="isProjectType">
            <ul>
              <!-- <li @click="filterProjectsByExternal('التنفيذ')">
                التنفيذ
                <span v-if="false">0</span>
              </li>
              <li @click="filterProjectsByExternal('الإغلاق')">
                الإغلاق
                <span v-if="false">0</span>
              </li>
              <li @click="filterProjectsByExternal('البدء')">
                البدء
                <span v-if="false">0</span>
              </li>
              <li @click="filterProjectsByExternal('التخطيط')">
                التخطيط
                <span v-if="false">0</span>
              </li> -->
               <li @click="filterProjectsByProjectType('داخلي')">
                داخلي
                <span v-if="false">0</span>
              </li>
              <li @click="filterProjectsByProjectType('خارجي')">
                خارجي
                <span v-if="false">0</span>
              </li>
              <li @click="filterProjectsByProjectType('طلب التغيير')">
                طلب التغيير
                <span v-if="false">0</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="dropdown-filter" @click="openInternalProjects">
          <img
            src="@/assets/images/icons/v3-angledown.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'light' || theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/angle-down-td.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'dark'"
          />
          <span v-if="lang == 'en'">Internal Project</span>
          <span v-if="lang == 'ar'">مشاريع الداخلية</span>

          <div class="filter-dropdown" v-if="isInternalProject">
            <ul>
              <li @click="filterProjectsByInternal('التنفيذ')">
                التنفيذ
                <span v-if="false">0</span>
              </li>
              <li @click="filterProjectsByInternal('الإغلاق')">
                الإغلاق
                <span v-if="false">0</span>
              </li>
              <li @click="filterProjectsByInternal('البدء')">
                البدء
                <span v-if="false">0</span>
              </li>
              <li @click="filterProjectsByInternal('التخطيط')">
                التخطيط
                <span v-if="false">0</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="dropdown-filter" @click="openMiscFilter">
          <img
            src="@/assets/images/icons/v3-angledown.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'light' || theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/angle-down-td.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'dark'"
          />
          <span v-if="lang == 'en'">Select Filter</span>
          <span v-if="lang == 'ar'">أختر</span>

          <div class="filter-dropdown" v-if="isMiscFilter">
            <ul>
              <li @click="filterProjectsByMisc('مبادرات مجلس الإدارة')">
                مبادرات مجلس الإدارة
              </li>
              <li style="cursor: default; font-weight: 800 !important">
                متوائمة
              </li>
              <li @click="filterProjectsByMisc('مشاريع السنة الحالي')">
                مشاريع السنة 2022
                <span v-if="false">{{
                  projects.filter((item) => {
                    let date = new Date(item.ProjectFinishDate);
                    if (
                      date.getFullYear() == new Date().getFullYear() &&
                      item.IsAligned == "نعم"
                    ) {
                      return item;
                    }
                  }).length
                }}</span>
              </li>
              <li @click="filterProjectsByMisc('مشاريع السنة القادم')">
                مشاريع السنة 2023
                <span v-if="false">{{
                  projects.filter((item) => {
                    let date = new Date(item.ProjectFinishDate);
                    if (
                      date.getFullYear() == new Date().getFullYear() + 1 &&
                      item.IsAligned == "نعم"
                    ) {
                      return item;
                    }
                  }).length
                }}</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="dropdown-filter" @click="openTierFilter">
          <img
            src="@/assets/images/icons/v3-angledown.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'light' || theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/angle-down-td.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'dark'"
          />
          <span v-if="lang == 'en'">Select Filter</span>
          <span v-if="lang == 'ar'">أختر</span>

          <div class="filter-dropdown" v-if="isTierVisible">
            <ul>
              <!--  <li @click="filterProjectsByTier('Special Tier (1)')">
                Special Tier (1)
                <span>{{ projects.filter(item => item.Priority == 'Special Tier (1)').length }}</span>

              </li>-->
              <li @click="filterProjectsByTier('Tier (1)')">
                Tier (1)
                <span v-if="false">{{
                  projects.filter((item) => item.Priority == "Tier (1)").length
                }}</span>
              </li>
              <li @click="filterProjectsByTier('Tier (2)')">
                Tier (2)
                <span v-if="false">{{
                  projects.filter((item) => item.Priority == "Tier (2)").length
                }}</span>
              </li>
              <li @click="filterProjectsByTier('Tier (3)')">
                Tier (3)
                <span v-if="false">{{
                  projects.filter((item) => item.Priority == "Tier (3)").length
                }}</span>
              </li>
              <li @click="filterProjectsByTier('لا ينطبق')">
                لا ينطبق
                <span v-if="false">{{
                  projects.filter((item) => item.Priority == "لا ينطبق").length
                }}</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="dropdown-filter" @click="openAlignmentFilter">
          <img
            src="@/assets/images/icons/v3-angledown.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'light' || theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/angle-down-td.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'dark'"
          />
          <span v-if="lang == 'en'">هل المشروع متوائم؟</span>
          <span v-if="lang == 'ar'">هل المشروع متوائم؟</span>

          <div class="filter-dropdown" v-if="isProjectAlignment">
            <ul>
              <li @click="filterProjectsByAlignment('نعم')">
                متوائم
                <span v-if="false">{{
                  projects.filter((item) => item.IsAligned == "نعم").length
                }}</span>
              </li>
              <li @click="filterProjectsByAlignment('التواريخ')">
                غير متوائم(التواريخ)
                <span v-if="false">{{
                  projects.filter(
                    (item) =>
                      item.IsAligned == "لا" && item.NotAligned == "التواريخ"
                  ).length
                }}</span>
              </li>
              <li @click="filterProjectsByAlignment('النطاق')">
                غير متوائم(النطاق)
                <span v-if="false">{{
                  projects.filter(
                    (item) =>
                      item.IsAligned == "لا" && item.NotAligned == "النطاق"
                  ).length
                }}</span>
              </li>
              <li @click="filterProjectsByAlignment('التواريخ و النطاق')">
                غير متوائم(الكل)
                <span v-if="false">{{
                  projects.filter(
                    (item) =>
                      item.IsAligned == "لا" &&
                      item.NotAligned == "التواريخ و النطاق"
                  ).length
                }}</span>
              </li>
              <!--   <li @click="filterProjectsByAlignment('لا ينطبق')">
                لا ينطبق
                <span>{{ projects.filter(item => item.IsAligned == 'لا ينطبق').length }}</span>
                
              </li>-->
              <li @click="filterProjectsByAlignment('TBD')">
                TBD
                <span v-if="false">{{
                  projects.filter((item) => item.IsAligned == "TBD").length
                }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="cf-project-count"  v-if="filteredProjects">
        <h1>
          عدد المشاريع
          <span>{{`( ${filteredProjects.length} )` }}</span>
        </h1>
      </div>

      <div class="col-12" v-if="projectData.tileView">
        <project-loader v-if="isProjectLoader" />
        <div class="row" v-if="!isProjectLoader">
          <div
            class="col-4 filter-data-tile"
            v-for="(project, index) in filteredProjects"
            :key="project.index"
           
          >
          <a :href="`/#/project-ar?id=${project.ProjectUID}`" target="_blank">
            <div class="tilehead trimed-title">
              <!-- new code added -->
              <template v-for="milestone in projectData.milestones" :key="milestone.TaskUID">
                <div class="task-check" v-if="milestone.ProjectUID == project.ProjectUID" >
                    <img src="@/assets/images/icons/green.svg" alt="#"/>
                </div>
                <!--ends-->
              </template>
              <h1 v-if="lang == 'ar'">
                {{ project.ProjectName }}
              </h1>
              <h1 v-if="lang == 'en'">{{ project.ProjectName }}</h1>

              <h2 v-if="lang == 'ar' && project.ProjectStatus == 'متأخر'">
                <span class="late">متأخر</span>
              </h2>
              <h2 v-if="lang == 'en' && project.ProjectStatus == 'متأخر'">
                <span class="late">Late</span>
              </h2>

              <h2 v-if="lang == 'ar' && project.ProjectStatus == 'ملغي'">
                <span class="archived">ملغي</span>
              </h2>
              <h2 v-if="lang == 'en' && project.ProjectStatus == 'ملغي'">
                <span class="archived ">Archived</span>
              </h2>

              <h2 v-if="lang == 'ar' && project.ProjectStatus == 'حسب المخطط'">
                <span class="onplanned">ﺣﺴﺐ اﻟﻤﺨﻄﻂ</span>
              </h2>
              <h2 v-if="lang == 'en' && project.ProjectStatus == 'حسب المخطط'">
                <span class="onplanned">As Planned</span>
              </h2>

              <h2
                v-if="
                  lang == 'ar' && project.ProjectStatus == 'تم الاطلاق(مكتمل)'
                "
              >
                <span class="completed">تم الاطلاق(مكتمل)</span>
              </h2>
              <h2
                v-if="
                  lang == 'en' && project.ProjectStatus == 'تم الاطلاق(مكتمل)'
                "
              >
                <span class="completed">Completed</span>
              </h2>
              <h2
                v-if="
                  lang == 'ar' &&
                  project.ProjectStatus == 'متوقع التأخير/ملاحظة مهمة'
                "
              >
                <span class="expectedlate">متوقع التأخير</span>
              </h2>
              <h2
                v-if="
                  lang == 'en' &&
                  project.ProjectStatus == 'متوقع التأخير/ملاحظة مهمة'
                "
              >
                <span class="expectedlate">Expected Late</span>
              </h2>
              <h3>
                (

                {{ project.ProjectPhase }}

                )
              </h3>

              <div class="project-progress-date">
                
                <div class="pinfo">
                  <span>{{getOnlyDate(project.ProjectStartDate)}}</span>
                  <span>{{getOnlyDate(project.ProjectFinishDate)}}</span>
                </div>
                <div class="progress">
                  <div class="progress-bar" role="progressbar" :style="`width: ${calculateProjectDateProgress(project.ProjectStartDate,project.ProjectFinishDate)}%`"></div>
                   <template v-for="(milestone,i) in projectData.milestones" :key="milestone.TaskUID">
                    <span style="display:none">{{i > 6 ? i = 1 : '' }}</span>
                    <div 
                    :style="`left:${i * 15 + 5}%!important`"
                    :class="`diamond ${
                      milestone.TaskStatus == 'متأخر' ? 'late' :
                      milestone.TaskStatus == 'حسب المخطط' ? 'onplanned' :
                      milestone.TaskStatus == 'مكتمل' ? 'completed' :
                      milestone.TaskStatus == 'متوقع التأخير/ملاحظة مهمة' ? 'expectedlate' : 'onplanned'
                    }`" :title="`${ milestone.TaskName }`" v-if="milestone.ProjectUID == project.ProjectUID && i < 6"></div>
                  </template>

                </div>
              </div>
            </div>

            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-6 round-chart">
                  <h1 v-if="lang == 'ar'">نسبة الأنجاز</h1>
                  <h1 v-if="lang == 'en'">Progress</h1>
                  <div class="col-12 ch halfcut1">
                    <halfcut-progress-lite
                      v-if="true"
                      :baseContainer="`first-progress-${index}`"
                      :valueContainer="`first-value-container-${index}`"
                      color="#48B0C4"
                      :data="project.ActualCompletePercent"
                    />
                    <half-cut-progress-v3
                      v-if="false"
                      :id="`halfcut${index}`"
                      color="#48B0C4"
                      :data="project.ActualCompletePercent"
                      title="الأنجاز"
                    />
                  </div>
                  <h2 v-if="lang == 'ar'">
                    المخطط
                    <b>%{{ project.PlannedCompletePercent }}</b>
                  </h2>
                  <h2 v-if="lang == 'en'">
                    Planned
                    <b>{{ project.PlannedCompletePercent }}%</b>
                  </h2>
                  <h2 v-if="lang == 'ar'">
                    الفعلي
                    <b>%{{ project.ActualCompletePercent }}</b>
                  </h2>
                  <h2 v-if="lang == 'en'">
                    Actual
                    <b>{{ project.ActualCompletePercent }}%</b>
                  </h2>
                </div>
                <div class="col-lg-6 round-chart">
                  <h1 v-if="lang == 'ar'">الميزانية</h1>
                  <h1 v-if="lang == 'en'">Budget</h1>

                  <div class="col-12 ch halfcut2">
                    <halfcut-progress-lite
                      :baseContainer="`second-progress-${index}`"
                      :valueContainer="`second-value-container-${index}`"
                      color="#B7B471"
                      :data="
                        project.ContractValue == 0 ||
                        project.ContractValue == null
                          ? 0
                          : (parseInt(project.PaidAmount.replace(/,/g, '')) /
                              project.ContractValue) *
                            100
                      "
                    />

                    <half-cut-progress-v3
                      v-if="false"
                      :id="`halfcut-a${index}`"
                      color="#B7B471"
                      :data="
                        project.ContractValue == 0
                          ? 0
                          : (parseInt(project.PaidAmount.replace(/,/g, '')) /
                              project.ContractValue) *
                            100
                      "
                      title="الميزانية"
                    />
                  </div>
                  <!-- {{ (halfcut.chartId1 = halfcut.chartId1 + 1) }}
                  {{ (halfcut.chartId2 = halfcut.chartId2 + 2) }} -->

                  <h2 v-if="lang == 'ar'">
                    المخطط
                    <b>{{ numeralFormatter(project.ContractValue) }}</b>
                  </h2>
                  <h2 v-if="lang == 'en'">
                    Planned
                    <b>{{ numeralFormatter(project.ContractValue) }}</b>
                  </h2>
                  <h2 v-if="lang == 'ar'">
                    المنصرف
                    <b>{{ numeralFormatter(project.PaidAmount) }}</b>
                  </h2>
                  <h2 v-if="lang == 'en'">
                    Spent
                    <b>{{ numeralFormatter(project.PaidAmount) }}</b>
                  </h2>
                </div>
              </div>
            </div>
           <div class="bottom-description">
              <h1 v-if="lang == 'ar'">
                <img src="@/assets/images/icons/comment-feedback.svg" alt="#" />
                إفادة الجهة المالكة
              </h1>
              <h1 v-if="lang == 'en'">
                <img src="@/assets/images/icons/comment-feedback.svg" alt="#" />
                Comments from sector
              </h1>
              <p v-if="lang == 'ar'">
                {{ project.sector_efada }}
              </p>
              <p v-if="lang == 'en'">
                {{ project.sector_efada }}
              </p>
            </div>
            <div class="bottom-description">
              <h1 v-if="lang == 'ar'">
                <img src="@/assets/images/icons/write-feedback.svg" alt="#" />
                إفادة تقنية المعلومات
              </h1>
              <h1 v-if="lang == 'en'">
                <img src="@/assets/images/icons/write-feedback.svg" alt="#" />
                Comments from IT
              </h1>
              <p v-if="lang == 'ar'">
                {{ project.AlignedComments }}
              </p>
              <p v-if="lang == 'en'">
                {{ project.AlignedComments }}
              </p>
            </div>
            <div class="bottom-description">
              <h1 v-if="lang == 'ar'">
                <img src="@/assets/images/icons/write-feedback.svg" alt="#" />
                ملاحظات EPMO
              </h1>
              <h1 v-if="lang == 'en'">
                <img src="@/assets/images/icons/write-feedback.svg" alt="#" />
                Comments from EPMO
              </h1>
              <p v-if="lang == 'ar'">
                {{ project.pmo_efada }}
              </p>
              <p v-if="lang == 'en'">
                {{ project.pmo_efada }}
              </p>
            </div>
          </a>  
          </div>
        </div>
      </div>
      <div class="col-12 table-container" v-if="projectData.tableView">
        <table class="table-responsive">
          <thead>
            <tr v-if="lang == 'ar'">
              <th>إسم المشروع</th>
              <th class="date">تاريخ البداية</th>
              <th class="date">تاريخ النهاية</th>
              <th class="">القطاع</th>
              <th class="status">المرحلة</th>
              <th class="status">الحالة</th>

              <th>إفادة الجهة المالكة</th>
              <th>إفادة تقنية المعلومات</th>
              <th>EPMO ملاحظات</th>
              
            </tr>
            <tr v-if="lang == 'en'">
              <th>Project Name</th>
              <th class="date">Start Date</th>
              <th class="date">Finish Date</th>
              <th>Sector</th>
              <th class="status">Phase</th>
              <th class="status">Status</th>

              <th>Department Feedback</th>
              <th>Alignment Feedback</th>
              <th>PMO Feedback</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="shade"
              v-for="project in filteredProjects"
              :key="project.status"
            >
              <td>{{ project.ProjectName }}</td>
              <td class="center eng">
                {{ project.ProjectStartDate.substr(0, 10) }}
              </td>
              <td class="center eng">
                {{ project.ProjectFinishDate.substr(0, 10) }}
              </td>
              <td>{{ project.ProjectSector }}</td>
              <td class="center eng">
                {{ project.ProjectPhase }}
              </td>
              <td
                class="late center"
                v-if="lang == 'ar' && project.ProjectStatus == 'متأخر'"
              >
                <span>متأخر</span>
              </td>
              <td
                class="late center"
                v-if="lang == 'en' && project.ProjectStatus == 'متأخر'"
              >
                <span>Late</span>
              </td>
              <td
                class="onplanned center"
                v-if="lang == 'ar' && project.ProjectStatus == 'حسب المخطط'"
              >
                <span>حسب المخطط</span>
              </td>
              <td
                class="onplanned center"
                v-if="lang == 'en' && project.ProjectStatus == 'حسب المخطط'"
              >
                <span>As Planned</span>
              </td>
              <td
                class="completed center"
                v-if="
                  lang == 'ar' && project.ProjectStatus == 'تم الاطلاق(مكتمل)'
                "
              >
                <span>تم الاطلاق(مكتمل)</span>
              </td>
              <td
                class="completed center"
                v-if="
                  lang == 'en' && project.ProjectStatus == 'تم الاطلاق(مكتمل)'
                "
              >
                <span>Completed</span>
              </td>
              <td
                class="expectedlate center"
                v-if="
                  lang == 'ar' &&
                  project.ProjectStatus == 'متوقع التأخير/ملاحظة مهمة'
                "
              >
                <span>متوقع التأخير</span>
              </td>
              <td
                class="expectedlate center"
                v-if="
                  lang == 'en' &&
                  project.ProjectStatus == 'متوقع التأخير/ملاحظة مهمة'
                "
              >
                <span>Expected Late</span>
              </td>

              <td>{{ project.sector_efada }}</td>
              <td>{{ project.AlignedComments }}</td>
              <td>{{ project.pmo_efada }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <FooterUnfixed/>
  </div>
</template>





<script>
// Dependencies
import store from "@/store";
import router from "@/router";
import Swal from "sweetalert2";
import axios from "axios"; //uncomment when using api

// Components
import Loader from "@/components/loader.vue";
import ProjectLoader from "@/components/project-loader.vue";
import PieV3 from "@/components/charts/pie-v3.vue";
import CircularPieV3 from "@/components/charts/circular-pie-v3.vue";
import DynamicCircularPieV3 from "@/components/charts/dynamic-circular-pie-v3.vue";
import CircularPieFilterV3 from "@/components/charts/circular-pie-filter-v3.vue";
import CircularProgressV3 from "@/components/charts/circular-progress-v3.vue";
import HalfCutProgressV3 from "@/components/charts/half-cut-progress-v3.vue";
import HalfcutProgressLite from "@/components/charts/half-cut-progress-lite.vue";
import ThemeTogglerV3 from "@/components/theme-toggler-v3.vue";
import LangTogglerV3 from "@/components/lang-toggler-v3.vue";
import SearchFilter from "@/components/search-filter.vue";
import FooterUnfixed from "@/components/footer-unfixed.vue";

// import $ from 'jquery';

// Local data fetch for testign
import { projects } from "@/static/projectdataset.js";
import { risks } from "@/static/riskprojects.js";
import { milestones } from "@/static/milestones.js";

export default {
  name: "DashV3-dev",
  components: {
    Loader,
    ProjectLoader,
    CircularPieV3,
    DynamicCircularPieV3,
    CircularPieFilterV3,
    CircularProgressV3,
    HalfCutProgressV3,
    HalfcutProgressLite,
    PieV3,
    ThemeTogglerV3,
    LangTogglerV3,
    SearchFilter,
    FooterUnfixed
  },
  computed: {
    theme() {
      return store.getters.getCurrentTheme;
    },
    lang() {
      return store.getters.getCurrentLang;
    },
    env() {
      return store.getters.getEnv;
    },
    projects() {
      return store.getters.getProjects;
    },
    filteredProjects() {
      return store.getters.getFilteredProjects;
    },
    activeTab() {
      return store.getters.getActiveTab;
    },
    activeFilter() {
      return store.getters.getActiveFilter;
    },
  },
  data() {
    return {
      isLoader: false,
      isProjectLoader: false,
      isTierVisible: false,
      isProjectAlignment: false,
      isMiscFilter: false,
      isInternalProject: false,
      isExternalProject: false,
      isProjectSector: false,
      isProjectRFP: false,
      isProjectClassification: false,
      isProjectType:false,
      filteredRisks: null,
      filteredIssues: null,
      filter: {
        risk: "all",
        issue: "all",
      },

      activeFilters: {
        health: "all",
        tier: "",
        alignment: "",
        misc: "",
        internal: "",
        projectType: "",
        sector: "",
        rfp: "",
        classification: "",
      },
      fireSwal: false,
      projectData: {
        risks: [],
        issues: [],
        milestones: [],
        projects: [],
        tileView: true,
        tableView: false,
        contractValue: 0,
        approvedBudget: 0,
        paidAmount: 0,
        risk: {
          veryHigh: 0,
          high: 0,
          moderate: 0,
          low: 0,
          nonImpact: 0,
        },
        currentYear: {
          contractValue: 0,
          approvedBudget: 0,
          totalProject: 0,
          paidAmount: 0,
        },
        progressChart: {
          allPercentageValue: 0,
          currentYearPercentageValue: 0,
        },
        pieChart: {
          isData: false,
          late: 0,
          expectedLate: 0,
          completed: 0,
          onplanned: 0,
        },
        internalProjects: {
          isData: false,
          executed: 0,
          planned: 0,
          opened: 0,
          closed: 0,
        },
        projectType: {
          isData: false,
          external: 0,
          internal: 0,
          changeRequest: 0,
        },
        externalProjects: {
          isData: false,
          executed: 0,
          planned: 0,
          opened: 0,
          closed: 0,
        },
        projectSector: {
          isData: false,
          totalSectors: 0,
          labels: [],
        },
        contractStatus: {
          isData: false,
          labels: [],
          totalContracts: 0,
          colors: [
            { stop1: "#85D7E0", stop2: "#85D7E0" },
            { stop1: "#9DF0FA", stop2: "#9DF0FA" },
            { stop1: "#78D3DC", stop2: "#78D3DC" },
            { stop1: "#5EBEC8", stop2: "#5EBEC8" },
            { stop1: "#399CA6", stop2: "#399CA6" },
            { stop1: "#2CA4B1", stop2: "#2CA4B1" },
            { stop1: "#2D7880", stop2: "#2D7880" },
            { stop1: "#13565C", stop2: "#13565C" },
            { stop1: "#238D98", stop2: "#238D98" },
            { stop1: "#2CA4B1", stop2: "#2CA4B1" },
            { stop1: "#31B1BF", stop2: "#31B1BF" },
            { stop1: "#3ABDCB", stop2: "#3ABDCB" },
          ],
        },
        catEfada: {
          isData: false,
          labels: [],
          totalEfada: 0,
          colors: [
            { stop1: "#6F98B2", stop2: "#6F98B2" },
            { stop1: "#85ABC3", stop2: "#85ABC3" },
            { stop1: "#C3E8FF", stop2: "#C3E8FF" },
            { stop1: "#99D8FE", stop2: "#99D8FE" },
            { stop1: "#4EABE3", stop2: "#4EABE3" },
            { stop1: "#3091CC", stop2: "#3091CC" },
            { stop1: "#0B4C73", stop2: "#0B4C73" },
            { stop1: "#7CEDE8", stop2: "#7CEDE8" },
            { stop1: "#105B89", stop2: "#105B89" },
            { stop1: "#166B9E", stop2: "#166B9E" },
            { stop1: "#1978B2", stop2: "#1978B2" },
          ],
        },
      },
    };
  },

   async updated (){
    this.trimmedTitles();
  },

  methods: {
    getOnlyDate: function (dateTime) {
      let date = new Date(dateTime);
      let year = date.getFullYear();
      let month =
        date.getMonth().toString().length > 1
          ? date.getMonth()
          : "0" + date.getMonth();
      let day =
        date.getDate().toString().length > 1
          ? date.getDate()
          : "0" + date.getDate();
      month = parseInt(month) + 1;
      let dateWithoutTime = day + "-" + month + "-" + year;
      return dateWithoutTime;
    },
    calculateProjectDateProgress(projectStartDate,projectFinishDate) {
      console.log(new Date(projectStartDate));
      console.log(new Date());
      
      if( new Date(projectStartDate) > new Date()) {
        console.log('0 Percent');
        return 0;
      }
      else if(new Date(projectFinishDate) <new Date()) {
        return 100;
      } else {
        const startDate = new Date(projectStartDate);
        const finishDate = new Date(projectFinishDate);
        const today = new Date();
        const diffTimeFinishStart = Math.abs(finishDate - startDate);
        let totalDays = Math.ceil(diffTimeFinishStart / (1000 * 60 * 60 * 24)); 
        const diffTimeTodayStartDate = Math.abs(today - startDate);
        const diffDays = Math.ceil(diffTimeTodayStartDate / (1000 * 60 * 60 * 24));

        // console.log(diffDays);
        // console.log(totalDays);
        

        if( totalDays == 0 ) {
          totalDays = 1;
        }
        return ((parseInt(diffDays) / parseInt(totalDays)) * 100).toFixed(2);
        
      }
    },
    navigate: function (page) {
      router.push(page);
    },

    openTierFilter: function () {
      this.isTierVisible = !this.isTierVisible;
      this.isProjectAlignment = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
    },
    openAlignmentFilter: function () {
      this.isProjectAlignment = !this.isProjectAlignment;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
    },
    openInternalProjects: function () {
      this.isInternalProject = !this.isInternalProject;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
    },
     openProjectType: function () {
      this.isProjectType = !this.isProjectType;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
    },
    openExternalProjects: function () {
      this.isExternalProject = !this.isExternalProject;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
    },
    openProjectSector: function () {
      this.isProjectSector = !this.isProjectSector;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
    },
    openRFP: function () {
      this.isProjectRFP = !this.isProjectRFP;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectClassification = false;
    },
    openProjectClassification: function () {
      this.isProjectClassification = !this.isProjectClassification;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
    },
    openMiscFilter: function () {
      this.isMiscFilter = !this.isMiscFilter;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
    },
    showSwal: function (icon, title, msg) {
      Swal.fire({
        icon: icon,
        title: title,
        text: msg,
      });
    },
    filterRisks: function (filter) {
      this.filter.risk = filter;
      if (filter == "all") {
        this.filteredRisks = this.projectData.risks;
      } else {
        this.filteredRisks = this.projectData.risks.filter(
          (item) => item.Exposure == filter
        );
      }
    },
    filterIssues: function (filter) {
      this.filter.issue = filter;
      if (filter == "all") {
        this.filteredIssues = this.projectData.issues;
      } else {
        this.filteredIssues = this.projectData.issues.filter(
          (item) => item.code == filter
        );
      }
    },
    filterProjects: async function (filter) {
      // Showing Project Loader
      this.isProjectLoader = true;
      this.activeFilters.health = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByTier: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.tier = filter;
      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
     this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByAlignment: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.alignment = filter;
      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByMisc: async function (filter) {
      // Showing Loader

      this.isProjectLoader = true;
      this.activeFilters.misc = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByInternal: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.internal = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByProjectType:  async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.projectType = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsBySector: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.sector = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByRFP: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.rfp = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByClassification: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.classification = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    applyHealth() {
      // Applying New Filter
      if (this.activeFilters.health == "all") {
        store.dispatch("setFilteredProjects", store.getters.getProjects);
      } else {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getProjects.filter(
            (item) => item.ProjectStatus == this.activeFilters.health
          )
        );
        // }
      }
    },
    applyTier() {
      if (this.activeFilters.tier != "") {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getFilteredProjects.filter(
            (item) => item.Priority == this.activeFilters.tier
          )
        );
      }
    },
    applyAlignment() {
      if (this.activeFilters.alignment != "") {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getFilteredProjects.filter((item) => {
            if (
              this.activeFilters.alignment == "نعم" ||
              this.activeFilters.alignment == "لا ينطبق" ||
              this.activeFilters.alignment == "TBD"
            ) {
              return item.IsAligned == this.activeFilters.alignment;
            } else if (
              (item.IsAligned == "لا" &&
                this.activeFilters.alignment == "التواريخ") ||
              (item.IsAligned == "لا" &&
                this.activeFilters.alignment == "النطاق") ||
              (item.IsAligned == "لا" &&
                this.activeFilters.alignment == "التواريخ و النطاق")
            ) {
              return item.NotAligned == this.activeFilters.alignment;
            }
          })
        );
      }
    },
    applyMisc() {
      if (this.activeFilters.misc == "مبادرات مجلس الإدارة") {
        // Applying New Filter
        store.dispatch(
          "setFilteredProjects",

          store.getters.getFilteredProjects.filter(
            (item) => item.boardinitiative == "نعم"
          )
        );
      }

      if (this.activeFilters.misc == "مشاريع السنة الحالي") {
        // Applying New Filter
        store.dispatch(
          "setFilteredProjects",

          store.getters.getFilteredProjects.filter((item) => {
            let date = new Date(item.ProjectFinishDate);
            if (
              date.getFullYear() == new Date().getFullYear() &&
              item.IsAligned == "نعم"
            ) {
              return item;
            }
          })
        );
      }
      //
      if (this.activeFilters.misc == "مشاريع السنة القادم") {
        store.dispatch(
          "setFilteredProjects",

          store.getters.getFilteredProjects.filter((item) => {
            let date = new Date(item.ProjectFinishDate);
            if (
              date.getFullYear() == new Date().getFullYear() + 1 &&
              item.IsAligned == "نعم"
            ) {
              return item;
            }
          })
        );
      }
    },
    applyInternal() {
      if (this.activeFilters.internal != "") {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getFilteredProjects.filter(
            (item) =>
              item.ProjectType == "داخلي" &&
              item.ProjectPhase == this.activeFilters.internal
          )
        );
      }
    },
    applyExternal() {
      if (this.activeFilters.external != "") {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getFilteredProjects.filter(
            (item) =>
              item.ProjectType == "خارجي" &&
              item.ProjectPhase == this.activeFilters.external
          )
        );
      }
    },
    applyProjectType() {
      if (this.activeFilters.projectType != "") {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getFilteredProjects.filter(
            (item) => item.ProjectType == this.activeFilters.projectType
          )
        );
      }
    },
    applySector() {
      if (this.activeFilters.sector != "") {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getFilteredProjects.filter(
            (item) => item.ProjectSector == this.activeFilters.sector
          )
        );
      }
    },
    applyRFP() {
      if (this.activeFilters.rfp != "") {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getFilteredProjects.filter(
            (item) => item.ContractStatus == this.activeFilters.rfp
          )
        );
      }
    },
    applyClassification() {
      if (this.activeFilters.classification != "") {
        store.dispatch(
          "setFilteredProjects",
          store.getters.getFilteredProjects.filter(
            (item) => item.cat_efada == this.activeFilters.classification
          )
        );
      }
    },
    makeActiveFilterNone: function (index) {
      if (index == 0) {
        this.activeFilters.health = "all";
      }
      if (index == 1) {
        this.activeFilters.tier = "";
      }
      if (index == 2) {
        this.activeFilters.alignment = "";
      }
      if (index == 3) {
        this.activeFilters.misc = "";
      }
      if (index == 4) {
        this.activeFilters.internal = "";
      }
      if (index == 5) {
        this.activeFilters.projectType = "";
      }
      // if (index == 5) {
      //   this.activeFilters.external = "";
      // }
      if (index == 6) {
        this.activeFilters.sector = "";
      }
      if (index == 7) {
        this.activeFilters.rfp = "";
      }
      if (index == 8) {
        this.activeFilters.classification = "";
      }

      this.isProjectLoader = true;

      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    changeProjectView: function (view) {
      if (view == "table") {
        this.projectData.tableView = true;
        this.projectData.tileView = false;
      }
      if (view == "tile") {
        this.projectData.tableView = false;
        this.projectData.tileView = true;
      }
    },
    numeralFormatter: function (number) {
      number = number.toString().replace(/,/g, "");
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "sar",
        minimumFractionDigits: 0,
      });
      if (number < 1000000 && number > 1000) {
        // Anything less than a million
        return formatter.format(number) + "K";
      } else if (number < 1000000000 && number > 1000000) {
        // Anything less than a billion
        number = number / 1000000;
        return formatter.format(number) + "M";
      } else if (number > 1000000000) {
        // At least a billion
        number = number / 1000000000;
        return formatter.format(number) + "B";
      } else {
        return formatter.format(number);
      }
    },
    makeNumeralFormatForBudget: function () {
      this.projectData.contractValue = this.numeralFormatter(
        this.projectData.contractValue
      );
      this.projectData.approvedBudget = this.numeralFormatter(
        this.projectData.approvedBudget
      );
      this.projectData.paidAmount = this.numeralFormatter(
        this.projectData.paidAmount
      );
      this.projectData.currentYear.contractValue = this.numeralFormatter(
        this.projectData.currentYear.contractValue
      );
      this.projectData.currentYear.approvedBudget = this.numeralFormatter(
        this.projectData.currentYear.approvedBudget
      );
      this.projectData.currentYear.paidAmount = this.numeralFormatter(
        this.projectData.currentYear.paidAmount
      );
    },
    calculatePercentageValue: function () {
      if (this.projectData.approvedBudget != 0) {
        this.projectData.progressChart.allPercentageValue = (
          (this.projectData.paidAmount / this.projectData.contractValue) *
          100
        ).toFixed(0);
      }
      if (this.projectData.currentYear.approvedBudget != 0) {
        this.projectData.progressChart.currentYearPercentageValue = (
          (this.projectData.currentYear.paidAmount /
            this.projectData.currentYear.contractValue) *
          100
        ).toFixed(0);
      }
    },
    calculatePiePercentageValue: function () {
      this.projectData.pieChart.late = this.projectData.projects.filter(
        (item) => item.ProjectStatus == "متأخر"
      ).length;
      this.projectData.pieChart.expectedLate = this.projectData.projects.filter(
        (item) => item.ProjectStatus == "متوقع التأخير/ملاحظة مهمة"
      ).length;
      this.projectData.pieChart.onplanned = this.projectData.projects.filter(
        (item) => item.ProjectStatus == "حسب المخطط"
      ).length;
      this.projectData.pieChart.completed = this.projectData.projects.filter(
        (item) => item.ProjectStatus == "تم الاطلاق(مكتمل)"
      ).length;

      this.projectData.pieChart.isData = true;
    },
    calculateInternalProjects: function () {
      for (let i = 0; i < this.projectData.projects.length; i++) {
        if (this.projectData.projects[i].ProjectType == "داخلي") {
          if (this.projectData.projects[i].ProjectPhase == "التنفيذ") {
            this.projectData.internalProjects.executed++;
          }
          if (this.projectData.projects[i].ProjectPhase == "التخطيط") {
            this.projectData.internalProjects.planned++;
          }
          if (this.projectData.projects[i].ProjectPhase == "الإغلاق") {
            this.projectData.internalProjects.closed++;
          }
          if (this.projectData.projects[i].ProjectPhase == "البدء") {
            this.projectData.internalProjects.opened++;
          }
        }
      }
      this.projectData.internalProjects.isData = true;
    },
    calculateExternalProjects: function () {
      for (let i = 0; i < this.projectData.projects.length; i++) {
        if (this.projectData.projects[i].ProjectType == "خارجي") {
          if (this.projectData.projects[i].ProjectPhase == "التنفيذ") {
            this.projectData.externalProjects.executed++;
          }
          if (this.projectData.projects[i].ProjectPhase == "التخطيط") {
            this.projectData.externalProjects.planned++;
          }
          if (this.projectData.projects[i].ProjectPhase == "الإغلاق") {
            this.projectData.externalProjects.closed++;
          }
          if (this.projectData.projects[i].ProjectPhase == "البدء") {
            this.projectData.externalProjects.opened++;
          }
        }
      }
      this.projectData.externalProjects.isData = true;
    },

    calculateProjectType: function () {
      for (let i = 0; i < this.projectData.projects.length; i++) {
        
          if (this.projectData.projects[i].ProjectType == "داخلي") {
            this.projectData.projectType.internal++;
          }
          if (this.projectData.projects[i].ProjectType == "خارجي") {
            this.projectData.projectType.external++;
          }
          if (this.projectData.projects[i].ProjectType == "طلب التغيير") {
            this.projectData.projectType.changeRequest++;
          }  
        
      }
      this.projectData.projectType.isData = true;
    },
    insertionSort: function (inputArr) {
      let n = inputArr.length;
      for (let i = 1; i < n; i++) {
        // Choosing the first element in our unsorted subarray
        let current = inputArr[i];
        // The last element of our sorted subarray
        let j = i - 1;
        while (j > -1 && current.value < inputArr[j].value) {
          inputArr[j + 1] = inputArr[j];
          j--;
        }
        inputArr[j + 1] = current;
      }
      // return inputArr;
    },
    calculateProjectSector: function () {
      const uniques = this.projectData.projects
        .map((item) => item.ProjectSector)
        .filter((value, index, self) => self.indexOf(value) === index);

      for (let i = 0; i < uniques.length; i++) {
        const feed = {};
        feed.key = uniques[i];
        feed.value = 0;
        this.projectData.projectSector.labels.push(feed);
      }

      // Now getting count
      for (let i = 0; i < this.projectData.projects.length; i++) {
        for (let j = 0; j < this.projectData.projectSector.labels.length; j++) {
          if (
            this.projectData.projects[i].ProjectSector ==
            this.projectData.projectSector.labels[j].key
          ) {
            this.projectData.projectSector.labels[j].value++;
          }
        }
      }
      for (let j = 0; j < this.projectData.projectSector.labels.length; j++) {
        this.projectData.projectSector.totalSectors +=
          this.projectData.projectSector.labels[j].value;
      }
      // Insertion Sort Logic for labels
      this.insertionSort(this.projectData.projectSector.labels);
      this.projectData.projectSector.isData = true;
    },
    calculateContractStatus: function () {
      let newData = this.projectData.projects.filter(
        (item) => item.ContractStatus != null && item.ContractStatus != ""
      );
      const uniques = newData
        .map((item) => item.ContractStatus.trim())
        .filter((value, index, self) => self.indexOf(value) === index);

      for (let i = 0; i < uniques.length; i++) {
        const feed = {};
        feed.key = uniques[i];
        feed.value = 0;
        this.projectData.contractStatus.labels.push(feed);
      }

      // Now getting count
      for (let i = 0; i < this.projectData.projects.length; i++) {
        for (
          let j = 0;
          j < this.projectData.contractStatus.labels.length;
          j++
        ) {
          if (
            this.projectData.projects[i].ContractStatus ==
            this.projectData.contractStatus.labels[j].key
          ) {
            this.projectData.contractStatus.labels[j].value++;
          }
        }
      }
      for (let j = 0; j < this.projectData.contractStatus.labels.length; j++) {
        this.projectData.contractStatus.totalContracts +=
          this.projectData.contractStatus.labels[j].value;
      }
      this.insertionSort(this.projectData.contractStatus.labels);
      this.projectData.contractStatus.isData = true;
    },
    calculateCatEfadaStatus: function () {
      let newData = this.projectData.projects.filter(
        (item) => item.cat_efada != null && item.cat_efada != ""
      );
      const uniques = newData
        .map((item) => item.cat_efada.trim())
        .filter((value, index, self) => self.indexOf(value) === index);

      for (let i = 0; i < uniques.length; i++) {
        const feed = {};
        feed.key = uniques[i];
        feed.value = 0;
        this.projectData.catEfada.labels.push(feed);
      }

      // Now getting count
      for (let i = 0; i < this.projectData.projects.length; i++) {
        for (let j = 0; j < this.projectData.catEfada.labels.length; j++) {
          if (
            this.projectData.projects[i].cat_efada ==
            this.projectData.catEfada.labels[j].key
          ) {
            this.projectData.catEfada.labels[j].value++;
          }
        }
      }
      for (let j = 0; j < this.projectData.catEfada.labels.length; j++) {
        this.projectData.catEfada.totalEfada +=
          this.projectData.catEfada.labels[j].value;
      }
      this.insertionSort(this.projectData.catEfada.labels);

      this.projectData.catEfada.isData = true;
    },
    disableDropdowns() {
      var binder = this;
      document.addEventListener('DOMContentLoaded',function(){
        let body = document.querySelector('body');
        body.addEventListener('click',function(e){
          if(!(e.target.classList.contains('dropdown-filter') || e.target.parentNode.classList.contains('dropdown-filter'))) {
            console.log('in if');
            binder.isTierVisible = false;
            binder.isProjectAlignment =false;
            binder.isMiscFilter = false;
            binder.isInternalProject = false;
            binder.isExternalProject = false;
            binder.isProjectSector = false;
            binder.isProjectRFP = false;
            binder.isProjectClassification = false;
            binder.isProjectType = false;
          }
        });
      });
    },

    trimmedTitles: function(){
      let headingTitle = document.querySelectorAll('.trimed-title h1');
        headingTitle.forEach(function(item){
        item.style.minHeight="65px";
        item.style.maxHeight="65px";
        item.style.overflow="hidden"; 
        item.style.padding="15px";   
    });
    },
  },
  async mounted() {
    // Fetching from api uncomment below three lines if using api
    if (this.env == "prod") {
      try {
        this.isLoader = true;
        const response = await axios.get(
          "https://pmoapi.sdb.gov.sa/api/proj/1",
          { withCredentials: true }
        );
        this.projectData.projects = JSON.parse(response.data[0]); //.filter(item => item.Priority == 'Special Tier (1)');
        this.projectData.risks = JSON.parse(response.data[1]);
        this.projectData.milestones = JSON.parse(response.data[2]);

        this.isLoader = false;
        if (this.projectData.risks == "False") {
          this.showSwal("error", "عذرا", "ليس لديك حق الوصول");
        } else {
          this.projectData.projects.map((item) => {
            if (item.ContractValue == null || item.ContractValue == "") {
              item.ContractValue = 0;
            }
            if (item.ApprovedBudget == null || item.ApprovedBudget == "") {
              item.ApprovedBudget = 0;
            }
            if (item.PaidAmount == null || item.PaidAmount == "") {
              item.PaidAmount = 0;
            }
            if (item.YearBudget == null || item.YearBudget == "") {
              item.YearBudget = 0;
            }
            if (item.SpentYearBudget == null || item.SpentYearBudget == "") {
              item.SpentYearBudget = 0;
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    }

    if (this.env == "dev") {
      // Fetching from local comment below three lines if using api
      this.projectData.projects = projects.filter(
        (item) => item.Priority == "Special Tier (1)"
      );
      this.projectData.risks = risks;
        this.projectData.milestones = milestones;
      this.projectData.projects.map((item) => {
        if (item.ContractValue == null || item.ContractValue == "") {
          item.ContractValue = 0;
        }
        if (item.ApprovedBudget == null || item.ApprovedBudget == "") {
          item.ApprovedBudget = 0;
        }
        if (item.PaidAmount == null || item.PaidAmount == "") {
          item.PaidAmount = 0;
        }
        if (item.YearBudget == null || item.YearBudget == "") {
          item.YearBudget = 0;
        }
        if (item.SpentYearBudget == null || item.SpentYearBudget == "") {
          item.SpentYearBudget = 0;
        }
      });
    }

    // let dateObj = new Date('dd-mm-yyyy');
    //console.log(projects);

    // Addition of contract value, approved budget, actual spent
    for (let i = 0; i < this.projectData.projects.length; i++) {
      this.projectData.contractValue +=parseInt(
        this.projectData.projects[i].ContractValue);
      this.projectData.approvedBudget +=parseInt(
        this.projectData.projects[i].ApprovedBudget);
      this.projectData.paidAmount += parseInt(
        this.projectData.projects[i].PaidAmount
      );

      // Calculating for current yeart
      let date = new Date(this.projectData.projects[i].ProjectStartDate);
      if (date.getFullYear() == new Date().getFullYear()) {
        this.projectData.currentYear.contractValue +=parseInt(
          this.projectData.projects[i].ContractValue);
        this.projectData.currentYear.approvedBudget +=parseInt(
          this.projectData.projects[i].ApprovedBudget);
        this.projectData.currentYear.paidAmount += parseInt(
          this.projectData.projects[i].PaidAmount
        );
        this.projectData.currentYear.totalProject++;
      }

      // Calculate Halfcut Filter chart value and percentage
      // this.calculateHalfCutPercentageValue(i);
    }

    // Calculate Progress Chart Percentage
    this.calculatePercentageValue();

    // Calculate Pie Filter chart value and percentage of Internal Projects
    this.calculateInternalProjects();

    // Calculate Pie Filter chart value and percentage of External Projects
    this.calculateExternalProjects();
    this.calculateProjectType();

    // Calculate Pie Filter chart value and percentage of Project Sectors
    this.calculateProjectSector();

    // Calculate Pie Filter chart value and percentage of Contract Value
    this.calculateContractStatus();

    // Calculate Pie Filter chart value and percentage of Cat Efada
    this.calculateCatEfadaStatus();

    // Calculate Pie Filter chart value and percentage
    this.calculatePiePercentageValue();

    // Disable Dropdwons
    this.disableDropdowns();

    // Numeral Format for budget of general years & current Year
    this.makeNumeralFormatForBudget();

    this.filteredRisks = this.projectData.risks;
    this.filteredIssues = this.projectData.issues;
    store.dispatch("setProjects", this.projectData.projects);
    store.dispatch("setFilteredProjects", this.projectData.projects);

    

    //removing checked Schedule icon
    setTimeout(function() {
    let tileHeads= document.querySelectorAll('.tilehead');
    tileHeads.forEach(function(item) {
      let taskChecks = item.querySelectorAll('.task-check');
        // console.log(taskChecks);

      taskChecks.forEach(function(item, index) {
        if(index > 0) {
          item.remove();
        }
      });
    });
    },1000);

     //trimming titles
      this.trimmedTitles();
  },
};
</script>

<style lang="scss">
@import "@/assets/css/global.scss";

body.ar {
  direction: rtl;
}
body.en {
  direction: ltr;
}

body.theme-light {
  background: $primary-background-light-v3;
}
body.theme-dark {
  background: $primary-background-dark-v3;
}
body.theme-medium {
  background: $primary-background-medium-v3;
}
</style>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";
@import "@/assets/css/v3-dash-ar-lmd";
@import "@/assets/css/v3-dash-en-lmd";
</style>
